import { useCallback, useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/contexts/AuthContext";
import type { RewardKey } from "@/lib/referral";

export type UserReward = {
  reward_key: RewardKey;
  unlocked_at: string;
  threshold: number | null;
};

export function useRewards() {
  const { user } = useAuth();
  const [rewards, setRewards] = useState<UserReward[]>([]);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    if (!user?.id) {
      setRewards([]);
      setLoading(false);
      return;
    }
    const { data } = await supabase
      .from("user_rewards")
      .select("reward_key, unlocked_at, threshold")
      .eq("user_id", user.id);
    setRewards((data ?? []) as UserReward[]);
    setLoading(false);
  }, [user?.id]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const has = useCallback(
    (key: RewardKey) => rewards.some((r) => r.reward_key === key),
    [rewards],
  );

  return { rewards, has, loading, refresh };
}
